import { format, parse } from "date-fns";

import { RiskType } from "../store/singleCase/types/Case";

const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: "smooth",
  });
};

const formatStringToUrl = (string: string) => {
  return string.replace(/\s+/g, "-").toLocaleLowerCase();
};

const getLastElementInArray = (array: any[]) => {
  return array.slice(-1)[0];
};

const scrollToRef = (ref: React.MutableRefObject<HTMLElement>) => {
  if (ref && ref.current) {
    ref.current.scrollIntoView({ behavior: "smooth", block: "center" });
  }
};

const childRisks = [RiskType.CHILD_COLLECTIVE, RiskType.CHILD_PRIVATE];

const calculateAgeFromNin = (nin: string) => {
  const birthMonth = parseInt(nin.slice(2, 4), 10);
  const birthDay = parseInt(nin.slice(0, 2), 10);
  const individualNumber = parseInt(nin.slice(6, 9), 10);

  const currentDate = new Date();
  let birthYear;

  if (individualNumber >= 0 && individualNumber <= 499) {
    birthYear = 1900 + parseInt(nin.slice(4, 6), 10);
  } else {
    birthYear = 2000 + parseInt(nin.slice(4, 6), 10);
  }

  if (currentDate.getMonth() + 1 === birthMonth) {
    if (currentDate.getDate() < birthDay) {
      return currentDate.getFullYear() - birthYear - 1;
    }
  }
  if (currentDate.getMonth() + 1 < birthMonth) {
    return currentDate.getFullYear() - birthYear - 1;
  }

  return currentDate.getFullYear() - birthYear;
};

const getBirthyearFromNin = (nin: string) => {
  const individualNumber = parseInt(nin.slice(6, 9), 10);

  let birthYear;

  if (individualNumber >= 0 && individualNumber <= 499) {
    birthYear = 1900 + parseInt(nin.slice(4, 6), 10);
  } else {
    birthYear = 2000 + parseInt(nin.slice(4, 6), 10);
  }

  return birthYear;
};

const getInitialsFromFirstAndLastName = (
  firstName: string,
  lastName: string,
) => {
  let initials = "";
  if (firstName) {
    initials += firstName.split("")[0].toUpperCase();
  }
  if (lastName) {
    initials += `${lastName.split("")[0].toUpperCase()}`;
  }
  return initials;
};

export enum DateFormat {
  SHORT = "dd.MM.yyyy",
  MEDIUM = "dd.MM.yyyy HH:mm",
  FULL = "dd.MM.yyyy HH:mm:ss",
}

/*
 * Beneficiary API returns this date format now, but accepts a different format as input
 * this might change
 * From beneficiary API: yyyy.MM.dd
 * Beneficiary API expects: dd.MM.yyyy
 */
const parseBeneficiaryDate = (
  input: string,
  dateFormat: DateFormat = DateFormat.SHORT,
) => {
  const date = parse(input, "yyyy-MM-dd", new Date());
  return format(date, dateFormat);
};

export const createBeneficiaryDate = (input: string) => {
  const date = parse(input, "dd.MM.yyyy", new Date());
  return format(date, "yyyy-MM-dd");
};

const parseJSR310Date = (
  input: number[],
  dateFormat: DateFormat = DateFormat.SHORT,
) => {
  if (input.length < 7) {
    return "";
  }

  const jsr310Date = [...input];
  const date = parse(
    jsr310Date.splice(0, 6).toString(),
    "yyyy,M,d,k,m,s",
    new Date(),
  );
  return format(date, dateFormat);
};

export {
  scrollToTop,
  scrollToRef,
  calculateAgeFromNin,
  formatStringToUrl,
  getLastElementInArray,
  getBirthyearFromNin,
  getInitialsFromFirstAndLastName,
  parseBeneficiaryDate,
  parseJSR310Date,
  childRisks,
};
